import StoreRepository from "../repositories/StoreRepository";
import DateService from "../services/DateService";
import Week from "../models/Week";
export default class DateManager {
    constructor(startDate) {
        this._dateRepository = new StoreRepository();
        this._dateService = new DateService();
        this._weekCount = 15;
        this._dayCount = 7;
        this._numberOfDays = this._weekCount * this._dayCount;
        this._monthOffset = 0;
        this._startDate = this._dateService.formatStartDate(startDate);
        this.calculateAndStoreDates();
    }
    calculateAndStoreDates() {
        for (let i = 0; i < this._numberOfDays; i++) {
            let dateObject = new Date();
            dateObject.setMonth(this._startDate.getMonth(), 1);
            dateObject.setDate(this._startDate.getDate() + i);
            let dateInput = {
                id: i,
                name: this._dateService.formatDateName(dateObject),
                week: Math.ceil((i + 1) / this._dayCount)
            };
            this._dateRepository.storeItem(this._dateService.mapInterfaceToModel(dateInput));
        }
    }
    getWeeksArray() {
        let array = [];
        let store = this._dateRepository.getStore();
        let weekCount = 0;
        for (let i = 0; i < this._numberOfDays; i++) {
            if (((i + this._dayCount) % this._dayCount) === 0) {
                let name = store[i].name + " - " + store[i + 6].name;
                array.push(new Week(++weekCount, name));
            }
        }
        return array;
    }
    calculateTimeFromBlockNumber(blockNumber) {
        let mins = blockNumber * 15;
        let hour = Math.floor(mins / 60).toString().padStart(2, "0");
        let min = ((mins / 60 - Math.floor(mins / 60)) * 60).toString().padStart(2, "0");
        return hour + ':' + min;
    }
}
